document.addEventListener('keydown', function (e) {
  if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;

  const gallery = document.querySelector('media-gallery');
  if (!gallery) return;

  const thumbnails = Array.from(
    gallery.querySelectorAll('button.slideshow-controls__thumbnail')
  );
  if (!thumbnails.length) return;

  // Find the currently active thumbnail via aria-selected
  const activeIndex = thumbnails.findIndex(
    (btn) => btn.getAttribute('aria-selected') === 'true'
  );

  let nextIndex;
  if (e.key === 'ArrowRight') {
    nextIndex = activeIndex === -1 ? 0 : (activeIndex + 1) % thumbnails.length;
  } else {
    nextIndex = activeIndex <= 0 ? thumbnails.length - 1 : activeIndex - 1;
  }

  thumbnails[nextIndex].click();
});
